import { freeze } from 'icepick';
import { SET, type SetAction } from './actions.tsx';
import type { AnalyticsData } from './types.tsx';

export type AnalyticsDataState = AnalyticsData;

export const initialState: AnalyticsDataState = {
	projectType: '',
};

type Action = SetAction;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: AnalyticsDataState = initialState, action: Action): AnalyticsDataState => {
	switch (action.type) {
		case SET: {
			return freeze(action.payload);
		}
		default:
			return state;
	}
};
